import { AvailableCountHandler } from "./AvailableCountHandler";
import { BookedEventsHandler } from "./BookedEventsHandler";
import { DateRangeEventHandler } from "./DateRangeEventHandler";
import { ExcludedIntervalHandler } from "./ExcludedIntervalHandler";
import { IncludedIntervalHandler } from "./IncludedIntervalHandler";
import merge from "lodash/merge";
var AvailabilityCollection = /** @class */ (function () {
    function AvailabilityCollection(handlers) {
        this.handlers = handlers;
    }
    AvailabilityCollection.prototype.getStatus = function (from, to, quantity, priority) {
        var statusData = null;
        for (var _i = 0, _a = this.handlers; _i < _a.length; _i++) {
            var handler = _a[_i];
            statusData = merge(statusData || {}, handler.getStatus(from, to, quantity, priority));
            if (!statusData.isAvailable) {
                return statusData;
            }
        }
        return statusData;
    };
    return AvailabilityCollection;
}());
export { AvailabilityCollection };
export var getSlotHandler = function (_a) {
    var availableSlots = _a.availableSlots, excludedSlots = _a.excludedSlots, bookedEvents = _a.bookedEvents, from = _a.from, to = _a.to, bookersCount = _a.bookersCount;
    return new AvailabilityCollection([
        new DateRangeEventHandler(from, to),
        new ExcludedIntervalHandler(excludedSlots),
        new BookedEventsHandler(bookedEvents, bookersCount),
        new AvailableCountHandler(bookersCount),
        new IncludedIntervalHandler(availableSlots),
    ]);
};
